export default __webpack_public_path__ + "static/media/b14.8d26eefa.png";